export default __webpack_public_path__ + "static/media/2555.99d7ad80.png";